module.exports = __webpack_public_path__ + "static/base-0ff0e2d23458ae7f1d411198961cbe2d.png";